/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusSpecialLineDto
 */
export interface NovitusSpecialLineDto {
    /**
     * Typ linii specjalnej
     * @type {string}
     * @memberof NovitusSpecialLineDto
     */
    type: NovitusSpecialLineDtoTypeEnum;
}


/**
 * @export
 */
export const NovitusSpecialLineDtoTypeEnum = {
    emptyline: 'emptyline',
    underline: 'underline',
    last_receipt_number: 'last_receipt_number'
} as const;
export type NovitusSpecialLineDtoTypeEnum = typeof NovitusSpecialLineDtoTypeEnum[keyof typeof NovitusSpecialLineDtoTypeEnum];


/**
 * Check if a given object implements the NovitusSpecialLineDto interface.
 */
export function instanceOfNovitusSpecialLineDto(value: object): value is NovitusSpecialLineDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function NovitusSpecialLineDtoFromJSON(json: any): NovitusSpecialLineDto {
    return NovitusSpecialLineDtoFromJSONTyped(json, false);
}

export function NovitusSpecialLineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusSpecialLineDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
    };
}

export function NovitusSpecialLineDtoToJSON(value?: NovitusSpecialLineDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
    };
}

